module.exports = __webpack_public_path__ + "static/media/landing-logo.623b4929.webp";